function initProductVariants() {

  const productSections =
    document.querySelectorAll(
      "[data-product-section]"
    );


  productSections.forEach(
    (section) => {

      const select =
        section.querySelector(
          "[data-product-variant-select]"
        );


      if (!select) {
        return;
      }


      if (
        section.dataset.variantInitialized ===
        "true"
      ) {
        return;
      }


      section.dataset.variantInitialized =
        "true";


      const price =
        section.querySelector(
          "[data-product-price]"
        );


      const comparePrice =
        section.querySelector(
          "[data-product-compare-price]"
        );


      const submitButton =
        section.querySelector(
          "[data-product-submit]"
        );


      const submitText =
        section.querySelector(
          "[data-product-submit-text]"
        );


      const paymentButton =
        section.querySelector(
          "[data-product-payment-button]"
        );


      function updatePrice(
        option
      ) {

        if (price) {

          price.textContent =
            option.dataset.price || "";

        }


        const comparePriceValue =
          option.dataset.comparePrice || "";


        if (!comparePrice) {
          return;
        }


        if (comparePriceValue) {

          comparePrice.textContent =
            comparePriceValue;


          comparePrice.hidden =
            false;


          price?.classList.add(
            "product-price-sale"
          );

        } else {

          comparePrice.textContent =
            "";


          comparePrice.hidden =
            true;


          price?.classList.remove(
            "product-price-sale"
          );

        }

      }


      function updateAvailability(
        option
      ) {

        const available =
          option.dataset.available ===
          "true";


        if (submitButton) {

          submitButton.disabled =
            !available;

        }


        if (submitText) {

          submitText.textContent =
            available
              ? "Add to Cart"
              : "Sold Out";

        }


        if (paymentButton) {

          paymentButton.hidden =
            !available;

        }

      }


      function updateURL(
        option
      ) {

        if (!option.value) {
          return;
        }


        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          "variant",
          option.value
        );


        window.history.replaceState(
          {
            variantId:
              option.value
          },
          "",
          url
        );

      }


      function updateImage(
        option
      ) {

        const imageId =
          option.dataset.imageId;


        if (!imageId) {
          return;
        }


        section.dispatchEvent(
          new CustomEvent(
            "product:image-change",
            {
              detail: {
                imageId
              }
            }
          )
        );

      }


      function updateVariant() {

        const option =
          select.options[
            select.selectedIndex
          ];


        if (!option) {
          return;
        }


        updatePrice(
          option
        );


        updateAvailability(
          option
        );


        updateURL(
          option
        );


        updateImage(
          option
        );


        /*
          Expose a general event in case
          another product feature needs
          variant information later.
        */

        section.dispatchEvent(
          new CustomEvent(
            "product:variant-change",
            {
              detail: {
                variantId:
                  option.value,

                available:
                  option.dataset.available ===
                  "true",

                price:
                  option.dataset.price || "",

                comparePrice:
                  option.dataset.comparePrice || "",

                imageId:
                  option.dataset.imageId || null
              }
            }
          )
        );

      }


      select.addEventListener(
        "change",
        updateVariant
      );


      /*
        Don't call updateVariant() here.

        Liquid already rendered the correct
        initial state, and doing so would
        unnecessarily rewrite the URL when
        somebody first opens the page.
      */

    }
  );

}


document.addEventListener(
  "DOMContentLoaded",
  initProductVariants
);


document.addEventListener(
  "shopify:section:load",
  initProductVariants
);


initProductVariants();